import { Component, OnInit, Input, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-flight-progress',
  templateUrl: './flight-progress.component.html',
  styleUrls: ['./flight-progress.component.scss']
})
export class FlightProgressComponent implements OnInit, AfterViewInit {
  @Input() data:any;
  remaininghours:number;
  progress: number = 0;
  guageCols: number = 4;
  minimalHrsRiskProgress:number = 0;
  atRisk:boolean = false;
  maximumHrsRisk:number = 0;
  monthsRemaining:number = 0;
  showMaxHoursAndMsg: boolean = false;
  startDate: any;
  endDate: any;
  
  constructor() { }

  ngOnInit() {

  }

ngAfterViewInit() {
  console.log('data from flight hours component to flight hours progress', this.data);
  this.remaininghours = this.data.MinimumHours - this.data.HoursFlown;
   if (this.remaininghours < 0){
     this.remaininghours = 0;
   }
   window.setTimeout(() => {
     let assetprogress = 0;
     if (this.data.maximumHours > 0) {
       this.showMaxHoursAndMsg = true;
       this.guageCols = 3;
       assetprogress = (this.data.HoursFlown * 100) /this.data.maximumHours;
     } else {
       this.showMaxHoursAndMsg = false;
       this.guageCols = 3;
       assetprogress = (this.data.HoursFlown * 100) /this.data.MinimumHours;
     }
    
    assetprogress = assetprogress -1.2;
     console.log('asset progress is' + assetprogress + '%');

     this.progress = assetprogress;
     
     this.startDate = new Date(this.data.ContractYearStart);
     this.endDate = new Date(this.startDate);
     this.endDate.setFullYear(this.endDate.getFullYear());
     this.endDate = new Date(this.endDate.setMonth(this.endDate.getMonth()-1));
     this.minimalHrsRiskProgress = this.calcRisk();
     this.monthsRemaining = 12 - this.calcMnths();
     if (this.monthsRemaining < 0) {
       this.monthsRemaining = 0
     }
   }, 800);
}

  calcRisk(){
    let riskProgessVal = 0;
    let totalEstimatedHrs = 0;
    let MnthsIn = this.calcMnths();
    console.log('This is the number of months in the contract',MnthsIn);
    let monthlyHrsNeeded = this.data.MinimumHours/12;
    
    let reportedTotalAvg = this.data.HoursFlown / MnthsIn;
    
    if (reportedTotalAvg < monthlyHrsNeeded) {

      riskProgessVal =  (reportedTotalAvg/monthlyHrsNeeded) *100;
      console.log('flight risk progress', riskProgessVal);
      this.atRisk = true;
    }

    return riskProgessVal;

  }

  calcMnths() {
    let lastreportDate:any = new Date(this.data.ReportedDate);
    let months = Math.abs(this.startDate - lastreportDate);
    months = months/2629746000; /* converts milliseconds into number of months */
    return months;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/flight-progress/flight-progress.component.ts